import React, { Fragment } from 'react'
import { Navigate, useLocation } from 'react-router-dom'

import styles from './SignUpSuccess.module.css'

import EntryForm, { ConfirmationCard } from 'Layout/EntryForm'
import Link from 'Design/components/Link'

const Body = () => {
  const { state } = useLocation()

  return (
    <Fragment>
      Please check <span className={styles.Email}>{state.email.toLowerCase()}</span> for verification link to get
      started with HappyFox Chatbot.
    </Fragment>
  )
}

const Footer = () => {
  return (
    <Fragment>
      <strong> Did not receive mail? </strong> Write to us at{' '}
      <Link href='mailto:support@happyfox.com'>support@happyfox.com</Link>
    </Fragment>
  )
}

const cardProps = {
  emoji: '👏',
  title: 'Thank you for signing up',
  body: <Body />,
  footer: <Footer />
}

const SignUpSuccess = () => {
  const location = useLocation()
  const state = location.state || {}

  if (!state.email) {
    return <Navigate to='/signup' />
  }

  return (
    <EntryForm>
      <ConfirmationCard {...cardProps} />
    </EntryForm>
  )
}

export default SignUpSuccess
